export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

export const formatCurrency = (value: number, decimals = 2): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

export const formatPercent = (value: number, decimals = 2): string => {
  return `${(value * 100).toFixed(decimals)}%`;
};

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleString();
};

export const getStatusColor = (status: string): string => {
  const colors: Record<string, string> = {
    healthy: 'text-green-400',
    operational: 'text-green-400',
    idle: 'text-blue-400',
    running: 'text-green-400',
    paused: 'text-yellow-400',
    offline: 'text-red-400',
    filled: 'text-green-400',
    pending: 'text-yellow-400',
    open: 'text-blue-400',
    cancelled: 'text-red-400',
  };
  return colors[status] || 'text-slate-300';
};

export const getStatusBg = (status: string): string => {
  const colors: Record<string, string> = {
    healthy: 'bg-green-400/20',
    operational: 'bg-green-400/20',
    idle: 'bg-blue-400/20',
    running: 'bg-green-400/20',
    paused: 'bg-yellow-400/20',
    offline: 'bg-red-400/20',
    filled: 'bg-green-400/20',
    pending: 'bg-yellow-400/20',
    open: 'bg-blue-400/20',
    cancelled: 'bg-red-400/20',
  };
  return colors[status] || 'bg-slate-400/20';
};
